module.exports = __webpack_public_path__ + "static/media/ds01.939cd3f0.jpg";